module.exports = __webpack_public_path__ + "static/media/icon_login_01.7696ba87.svg";